<template>
    <div class=page :id="post.slug">

        <component v-if="post.template" :is="post.template.replace('UpClose_', '')" :post="post"></component>

    </div>
</template>
<script>

export default {
    name : 'Page',
    props : {
        post : Object,
    },
    components : {
        RichTextPage        : () => import(/* webpackChunkName: "rich-text-page" */     '../views/RichTextPage.vue'      ),
        MenuPage            : () => import(/* webpackChunkName: "menu-page" */          '../views/MenuPage.vue'          ),
        EmbedPage           : () => import(/* webpackChunkName: "embed-page" */         '../views/EmbedPage.vue'         ),
        VideoPage           : () => import(/* webpackChunkName: "video-page" */         '../views/VideoPage.vue'         ),
        AudioPage           : () => import(/* webpackChunkName: "audio-page" */         '../views/AudioPage.vue'         ),
        LongComicPage       : () => import(/* webpackChunkName: "long-comic-page" */    '../views/LongComicPage.vue'     ),
        SlideshowPage       : () => import(/* webpackChunkName: "slideshow-page" */     '../views/SlideshowPage.vue'     ),
        ChatbotPage         : () => import(/* webpackChunkName: "chatbot-page" */       '../views/ChatbotPage.vue'       ),
        AudioTourPage       : () => import(/* webpackChunkName: "audio-tour-page" */    '../views/AudioTourPage.vue'     ),
        DateImageSlideshow  : () => import(/* webpackChunkName: "audio-tour-page" */    '../views/DateImageSlideshow.vue')
    },
}
</script>